import { colors } from '../theme';

const statuses = {
  active: { id: 0, color: colors.greenBright, title: 'Active' },
  ended: { id: 1, color: colors.pinkDark, title: 'Ended' },
  outOfStock: { id: 2, color: colors.greyDark, title: 'Out Of Stock' },
  removed: { id: 3, color: colors.greyInputBorder, title: 'Removed' },
  removedFromTripleMars: { id: 4, color: colors.greyMid, title: 'Removed From TripleMars' }
};

export const setStatusList = Object.keys(statuses).map(s => ({
  status: s,
  ...statuses[s],
}));

